import React, { useRef, useState } from 'react';
import { Container, Grid, Typography, Button, Box, TextField, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import BuzzHeader from '../Header/BuzzHeader';
import AutoScrollGallery from '../Items/AutoScrollGallery';
import AutoScrollBuzzPartners from '../Items/AutoScrollBuzzPartners';
import { useNavigate } from 'react-router-dom';
import { API_URL, BASE_URL } from '../ApiConfig';
import { Helmet } from 'react-helmet-async';

// Styled components
const DownloadButton = styled(Box)({
    margin: '10px',
    padding: '10px 20px',
    borderRadius: '3px',
    border: "1px solid #303030",
    cursor: 'pointer',
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex'
});



const AppImage = styled('img')({
    maxWidth: '100%',
    height: 'auto',
});

const HeroSection = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')
    return (
        <Box ref={ref} sx={{
            flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', display: 'flex', paddingTop: "80px"

        }}>

            <img style={{ alignSelf: 'stretch', height: "400px", objectFit: 'cover', position: 'absolute', width: "100%" }}
                src={isMobileScreen ? require("../../assets/images/home_back_mobile.svg") : require("../../assets/images/home_back_svg.svg")} />

            <Typography variant={isMobileScreen ? "h4" : isTabScreen ? "h3" : "h2"} component="h1" gutterBottom style={{
                fontFamily: 'Poppins', fontWeight: 700, textAlign: 'center', maxWidth: "800px", marginTop: isMobileScreen ? "20px" : "50px",
                lineHeight: isMobileScreen ? "50px" : isTabScreen ? "70px" : "90px", marginInline: '20px'
            }}>
                Connect, Meet, and Chat with People <span style={{
                    color: '#ffffff',
                    fontWeight: 500,
                    paddingInline: "15px",
                    background: '#706dea',
                    display: 'inline-block', transform: 'rotate(-2.5deg)'
                }}>Nearby!</span>
            </Typography>
            <Typography variant="body1" color="#303030" paragraph style={{
                fontFamily: 'Poppins', fontWeight: 500, maxWidth: "500px", textAlign: 'center', marginInline: "30px", marginTop: isMobileScreen ? "15px" : "0px"
            }}>
                Cerkle is your go-to app for meeting new people around you. Find and connect with people in real-time at your favorite spots, events, or local hangouts. Make meaningful connections with just a few taps.
            </Typography>


            <img style={{ height: "500px", objectFit: 'contain', alignSelf: 'stretch', marginTop: isMobileScreen ? "0px" : isTabScreen ? '0px' : "50px" }}
                src={isMobileScreen ? require("../../assets/images/home_mobile.png") : require("../../assets/images/home_gfx1.png")} />

            <Box sx={{ marginTop: isMobileScreen ? '10px' : '50px', flexDirection: isMobileScreen ? 'column' : 'row', display: 'flex' }}>
                <DownloadButton onClick={() => {
                    window.open('https://apps.apple.com/in/app/cerkle/id6749543299', '_blank');
                }} style={{
                    background: '#000000'
                }} variant="contained" color="#303030">
                    <img src={require("../../assets/images/apple.svg")} style={{ width: '18px', height: "18px", filter: "invert()" }} />
                    <Typography style={{
                        fontFamily: 'poppins',
                        fontSize: isMobileScreen ? '13px' : '16px',
                        fontWeight: 400,
                        color: '#ffffff',
                        marginLeft: "10px"
                    }} >Download from App Store</Typography>
                </DownloadButton>
                <DownloadButton onClick={() => {
                    window.open('https://play.google.com/store/apps/details?id=com.vybecerkle.cerkle', '_blank');
                }} variant="contained" color="#303030">
                    <img src={require("../../assets/images/play-store-dark.svg")} style={{ width: '18px', height: "18px", }} />
                    <Typography style={{
                        fontFamily: 'poppins',
                        fontSize: isMobileScreen ? '13px' : '16px',
                        fontWeight: isMobileScreen ? 500 : 400,
                        marginLeft: "10px",
                        flex: 1,
                        textAlign: 'center',
                        color: 'black'
                    }}>Get it on Google Play</Typography>
                </DownloadButton>

            </Box>

            <Box sx={{
                width: "70px", height: "5px", alignSelf: 'center', borderRadius: "30px", background: '#aaaaaa25',
                marginTop: "50px"
            }} />



            {/* <Typography style={{alignSelf:'stretch', background: '#010927', color: 'white', textTransform:'uppercase',
                paddingBottom: "30px", paddingTop: "30px", fontFamily:'Poppins', fontWeight: 500, fontSize: "28px", marginTop: "100px", overflow:'hidden', 
                textOverflow:'ellipsis',
                transform: 'rotate(-2.5deg)', marginInline: "-20px", paddingInline: "25px", whiteSpace:'nowrap'
            }}>
                    Find Your Spark <span style={{color:'#706dea'}}>•</span> Meet Your Perfect Match <span style={{color:'#706dea'}}>• </span> 
                    Connect Realtime <span style={{color:'#706dea'}}>•</span> Make Connection Instantly <span style={{color:'#706dea'}}>• </span> 
                    Find Your Spark <span style={{color:'#706dea'}}>•</span> Meet Your Perfect Match
                </Typography> */}
        </Box>
    );
});

const HowToBuzz = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')

    return (
        <Box ref={ref} sx={{ pt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                How to use Cerkle?
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={600} mx={"20px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                Its quite simple to start making connections
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={500} mx={"30px"} color={"#30303090"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center"
                maxWidth={"500px"}>
                There are only 3 steps to make your new connection on Cerkle, so are you excited to find your new friends, team members, recruiters and even job seekers?
            </Typography>

            <Box sx={{
                flexDirection: 'row', display: 'flex', alignSelf: 'center', mt: "60px", gap: "30px", flexWrap: 'wrap', justifyContent: 'center',
                alignItems: 'center'
            }}>

                <Box sx={{ width: "350px", height: "390px", background: '#ff880010', borderRadius: "10px", display: 'flex', flexDirection: 'column', padding: "20px" }}>
                    <Typography variant="h6" textAlign="center" style={{
                        alignSelf: 'flex-start',
                        fontFamily: 'poppins', fontWeight: 600, fontSize: "15px", background: '#ffffff', marginBottom: "20px",
                        paddingTop: "3px", paddingInline: "7px", borderRadius: "5px", paddingBottom: "3px",
                        textAlign: 'center', textAlignLast: 'center', verticalAlign: 'center', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        01
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"10px"} >
                        Discover
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} mb={"10px"} >
                        You can now discover people right around you ‘on-spot’ or ‘nearby’ just by the tag
                    </Typography>

                    <img src={require("../../assets/images/h1.png")} height={"230px"} style={{ alignSelf: 'stretch', objectFit: 'contain', }} />
                </Box>

                <Box sx={{ width: "350px", height: "390px", background: '#706dea10', borderRadius: "10px", display: 'flex', flexDirection: 'column', padding: "20px" }}>
                    <Typography variant="h6" textAlign="center" style={{
                        alignSelf: 'flex-start',
                        fontFamily: 'poppins', fontWeight: 600, fontSize: "15px", background: '#ffffff', marginBottom: "20px",
                        paddingTop: "3px", paddingInline: "7px", borderRadius: "5px", paddingBottom: "3px",
                        textAlign: 'center', textAlignLast: 'center', verticalAlign: 'center', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        02
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"10px"} >
                        Add Buzzline
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} mb={"10px"} >
                        Make effective connections by just adding why you want to connect with a ‘Buzzline’

                    </Typography>
                    <img src={require("../../assets/images/h2.png")} height={"230px"} style={{ alignSelf: 'stretch', objectFit: 'contain', }} />
                </Box>

                <Box sx={{ width: "350px", height: "390px", background: '#fff20010', borderRadius: "10px", display: 'flex', flexDirection: 'column', padding: "20px" }}>
                    <Typography variant="h6" textAlign="center" style={{
                        alignSelf: 'flex-start',
                        fontFamily: 'poppins', fontWeight: 600, fontSize: "15px", background: '#ffffff', marginBottom: "20px",
                        paddingTop: "3px", paddingInline: "7px", borderRadius: "5px", paddingBottom: "3px",
                        textAlign: 'center', textAlignLast: 'center', verticalAlign: 'center', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        03
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"10px"} >
                        Make Connection
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} >
                        Found someone interesting to connect with just send a catchy icebreaker and connect with them

                    </Typography>

                    <img src={require("../../assets/images/h3.png")} height={"230px"} style={{ alignSelf: 'stretch', objectFit: 'contain', }} />
                </Box>

            </Box>
        </Box>
    );
});


const FeaturesSection = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')
    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                Features
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={600} mx={"20px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                Features that can change the connection game
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={500} mx={"30px"} color={"#30303090"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center"
                maxWidth={"600px"}>
                All of your needs at one place find people according their location, add buzzline of your interest, send anonymous messages (chirps) and even join live rooms.
            </Typography>

            <Box sx={{
                flexDirection: 'row', display: 'flex', alignSelf: 'center', mt: "60px", gap: "20px", marginInline: '100px',
                flexWrap: 'wrap', justifyContent: 'center'
            }}>

                <Box sx={{
                    width: "280px", height: "220px", border: "1.8px solid #aaaaaa50", borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px"
                }}>
                    <img src={"data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48cGF0aCBmaWxsPSIjYzJmMmQ2IiBkPSJNMTkuOTE0LDEuODgzQTMuNzIyLDMuNzIyLDAsMCwwLDE2Ljg0OC44MDhsLTMuODg1LjQzMWEzLjc2NiwzLjc2NiwwLDAsMC0yLjIzNywxLjA3NUwyLjk4NCwxMC4wNTZhMy43NDksMy43NDksMCwwLDAsMCw1LjNsNS42NTgsNS42NThhMy43NDksMy43NDksMCwwLDAsNS4zLDBsNy43NDItNy43NDJhMy43NjYsMy43NjYsMCwwLDAsMS4wNzUtMi4yMzdsLjQzMS0zLjg4NWEzLjczLDMuNzMsMCwwLDAtMS4wNzUtMy4wNjZaIi8+PHBhdGggZmlsbD0iIzhmZTViMiIgZD0iTTE4LjU0MSw1LjQ1OWEyLjI0OCwyLjI0OCwwLDEsMCwwLDMuMTg0aDBBMi4yNTIsMi4yNTIsMCwwLDAsMTguNTQxLDUuNDU5WiIvPjxwYXRoIGZpbGw9IiMyZWNmODMiIGQ9Ik0xOC4wMTEsOC44NjFhLjc1Ljc1LDAsMCwxLS41MzEtMS4yOC43NS43NSwwLDEsMC0xLjA2LDAsLjc1MS43NTEsMCwxLDEtMS4wNjMsMS4wNjEsMi4yNTEsMi4yNTEsMCwxLDEsMy4xODQsMEEuNzQ3Ljc0NywwLDAsMSwxOC4wMTEsOC44NjFaIi8+PHBhdGggZmlsbD0iIzJlY2Y4MyIgZD0iTTExLjI5MywyMi4xMTRhMy43MjQsMy43MjQsMCwwLDEtMi42NTEtMS4xTDIuOTg0LDE1LjM1OGEzLjc0OSwzLjc0OSwwLDAsMSwwLTUuM2w3Ljc0Mi03Ljc0MmEzLjc2NiwzLjc2NiwwLDAsMSwyLjIzNy0xLjA3NUwxNi44NDguODA4YTMuNzIxLDMuNzIxLDAsMCwxLDMuMDY2LDEuMDc1bDIuMiwyLjJhMy43MywzLjczLDAsMCwxLDEuMDc1LDMuMDY2bC0uNDMxLDMuODg1YTMuNzY2LDMuNzY2LDAsMCwxLTEuMDc1LDIuMjM3bC03Ljc0Miw3Ljc0MkEzLjcyNSwzLjcyNSwwLDAsMSwxMS4yOTMsMjIuMTE0Wm01Ljk3My0xOS44M2EyLjM2NSwyLjM2NSwwLDAsMC0uMjUyLjAxNGwtMy44ODUuNDMxYTIuMjcsMi4yNywwLDAsMC0xLjM0My42NDZMNC4wNDUsMTEuMTE2YTIuMjUsMi4yNSwwLDAsMCwwLDMuMTgyTDkuNywxOS45NTVoMGEyLjMsMi4zLDAsMCwwLDMuMTgyLDBsNy43NDEtNy43NDFhMi4yNywyLjI3LDAsMCwwLC42NDYtMS4zNDNMMjEuNyw2Ljk4NmEyLjI0NCwyLjI0NCwwLDAsMC0uNjQ1LTEuODRsLTIuMi0yLjJBMi4yNDQsMi4yNDQsMCwwLDAsMTcuMjY2LDIuMjg0WiIvPjwvZz48L3N2Zz4="}
                        style={{
                            width: "50px", padding: "12px", height: "50px",
                            background: '#aaaaaa20', borderRadius: "10px"
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"20px"} >
                        Spot & Nearby Tag
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} >
                        Find someone right around you ‘on spot’ or someone just close by with the ‘nearby’ tag. Be in the moment.
                    </Typography>
                </Box>


                <Box sx={{
                    width: "280px", height: "220px", border: "1.8px solid #706dea70", background: '#706dea20', borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px"
                }}>
                    <img src={"data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iIzY1NjNmZiIgZD0iTTE3IDEzSDdhMSAxIDAgMCAxIDAtMmgxMGExIDEgMCAwIDEgMCAyWiIvPjxwYXRoIGZpbGw9IiNiMmIxZmYiIGQ9Ik0xMiAyYTEwIDEwIDAgMCAwLTcuNzQzIDE2LjMzbC0xLjk2NCAxLjk2M0ExIDEgMCAwIDAgMyAyMmg5YTEwIDEwIDAgMCAwIDAtMjBaTTkgN2g2YTEgMSAwIDAgMSAwIDJIOWExIDEgMCAwIDEgMC0yWm02IDEwSDlhMSAxIDAgMCAxIDAtMmg2YTEgMSAwIDAgMSAwIDJabTItNEg3YTEgMSAwIDAgMSAwLTJoMTBhMSAxIDAgMCAxIDAgMloiLz48cGF0aCBmaWxsPSIjNjU2M2ZmIiBkPSJNMTUgMTdIOWExIDEgMCAwIDEgMC0yaDZhMSAxIDAgMCAxIDAgMnptMC04SDlhMSAxIDAgMCAxIDAtMmg2YTEgMSAwIDAgMSAwIDJ6Ii8+PC9zdmc+"}
                        style={{
                            width: "50px", padding: "12px", height: "50px",
                            background: '#ffffff', borderRadius: "10px", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.09)',
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"20px"} >
                        Buzzline
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} >
                        An effective communicator to share your intent to connect at any given point of time.
                    </Typography>
                </Box>

                <Box sx={{
                    width: "280px", height: "220px", border: "1.8px solid #aaaaaa50", borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px"
                }}>
                    <img src={"data:image/svg+xml;utf8;base64,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"}
                        style={{
                            width: "50px", padding: "7px", height: "50px",
                            background: '#aaaaaa20', borderRadius: "10px"
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"20px"} >
                        Chirps
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} >
                        hey Anon!! Want to send anonymous texts to people just chirp and see if the other person wants to unmask you.
                    </Typography>
                </Box>

                <Box sx={{
                    width: "280px", height: "220px", border: "1.8px solid #ff880060", borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px", background: "#ff880015"
                }}>
                    <img src={"data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNiIgeDI9IjQyIiB5MT0iMjQiIHkyPSIyNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2YxMjcxMSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2Y1YWYxOSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Ik00MiwyNEExOCwxOCwwLDEsMSwxOC43MSw2Ljc4YTEsMSwwLDAsMSwuNTgsMS45MkExNiwxNiwwLDEsMCw0MCwyNGExNC43OCwxNC43OCwwLDAsMC0uMTgtMi4zNiwxLDEsMCwwLDEsMi0uMzJBMTcuNzcsMTcuNzcsMCwwLDEsNDIsMjRaTTE4LjU4LDEyLjE3QTEzLDEzLDAsMSwwLDM3LDI0LjI1YTEsMSwwLDAsMC0xLTEsMSwxLDAsMCwwLTEsMUExMSwxMSwwLDEsMSwxOS40MiwxNGExLDEsMCwxLDAtLjg0LTEuODJaTTIzLDE5LjFWN2ExLDEsMCwwLDEsMS0xLDE3LjkyLDE3LjkyLDAsMCwxLDE2LDkuNjdsMCwwdjBoMGEuMTEuMTEsMCwwLDEsMCwwLDEsMSwwLDAsMS0uNCwxLjI4TDI4LjkxLDIzLjE0QTQuODIsNC44MiwwLDAsMSwyOSwyNGE1LDUsMCwxLDEtNi00LjlaTTI1LDhWMTkuMWE1LDUsMCwwLDEsMy4xNywyLjE2bDkuNTctNS40NUExNS45NCwxNS45NCwwLDAsMCwyNSw4Wk0yMSwyNGEzLDMsMCwxLDAsMy0zQTMsMywwLDAsMCwyMSwyNFoiLz48L3N2Zz4="}
                        style={{
                            width: "50px", padding: "12px", height: "50px",
                            background: '#ffffff', borderRadius: "10px", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.09)'
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"19px"} component="h2" gutterBottom marginTop={"20px"} >
                        Rooms
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"13px"} >
                        Join Engaging Cerkle Rooms and interact with people and check what your immediate surroundings have to offer , Trivia Night ?
                    </Typography>
                </Box>



            </Box>
        </Box>
    );
});


const ConnectionTypes = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')
    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                Connection Types
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={600} mx={"20px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                Networks that can stay with you lifelong
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={500} mx={"30px"} color={"#30303090"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center"
                maxWidth={"500px"}>
                Cerkle is a place to build different genres of connections , just the way you scroll through movie genres , scroll through cerkle for the different Networking opportunities
            </Typography>

            <Box sx={{
                flexDirection: 'row', display: 'flex', alignSelf: 'center', mt: "60px", gap: "20px", flexWrap: 'wrap', justifyContent: 'center',
                alignItems: 'center'
            }}>

                <Box sx={{
                    width: "300px", height: "400px", border: "5px solid #ffffff", borderTopLeftRadius: "20px", borderTopRightRadius: "20px", display: 'flex', flexDirection: 'column',
                    overflow: 'hidden', position: 'relative'
                }}>


                    <img src={require("../../assets/images/ct1.png")} style={{ width: '300px', height: '400px', objectFit: 'cover' }} />

                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, paddingX: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff, #00000000, #00000000);', alignItems: 'center'
                    }}>

                        <Typography fontFamily={"poppins"} fontWeight={400} color={"#707070"} fontSize={"13px"} >
                            {/* Lorem ipsum dolor sit amet */}
                        </Typography>
                        <Typography fontFamily={"poppins"} fontWeight={300} color={"#000000"} fontSize={"18px"} component="h2" marginTop={"20px"} textAlign={'center'} >
                            Friends & Circle
                        </Typography>
                    </Box>


                </Box>


                <Box sx={{
                    width: "300px", height: "400px", border: "5px solid #ffffff", borderTopLeftRadius: "20px", borderTopRightRadius: "20px", display: 'flex', flexDirection: 'column',
                    overflow: 'hidden', position: 'relative'
                }}>


                    <img src={require("../../assets/images/ct2.png")} style={{ width: '300px', height: '400px', objectFit: 'cover' }} />

                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, paddingX: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff, #00000000, #00000000);', alignItems: 'center'
                    }}>

                        <Typography fontFamily={"poppins"} fontWeight={400} color={"#707070"} fontSize={"13px"} >
                            {/* Lorem ipsum dolor sit amet */}
                        </Typography>
                        <Typography fontFamily={"poppins"} fontWeight={300} color={"#000000"} fontSize={"18px"} component="h2" marginTop={"20px"} textAlign={'center'} >
                            Business & Professional
                        </Typography>
                    </Box>


                </Box>


                <Box sx={{
                    width: "300px", height: "400px", border: "5px solid #ffffff", borderTopLeftRadius: "20px", borderTopRightRadius: "20px", display: 'flex', flexDirection: 'column',
                    overflow: 'hidden', position: 'relative',
                }}>


                    <img src={require("../../assets/images/ct3.png")} style={{ width: '300px', height: '400px', objectFit: 'cover' }} />


                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, padding: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff90, #00000000, #00000000);', alignItems: 'center'
                    }}>

                    </Box>

                    <Box sx={{
                        position: 'absolute', bottom: 0, paddingX: "15px", width: '300px', height: "300px", display: 'flex', flexDirection: 'column-reverse',
                        background: 'linear-gradient(0deg, #ffffff, #00000000, #00000000);', alignItems: 'center'
                    }}>

                        <Typography fontFamily={"poppins"} fontWeight={400} color={"#707070"} fontSize={"13px"} >
                            {/* Lorem ipsum dolor sit amet */}
                        </Typography>
                        <Typography fontFamily={"poppins"} fontWeight={300} color={"#000000"} fontSize={"18px"} component="h2" marginTop={"20px"} textAlign={'center'} >
                            Utility Based
                        </Typography>
                    </Box>


                </Box>


            </Box>
        </Box>
    );
});


const BuzzPartnered = React.forwardRef((props, ref) => {
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')

    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                Cerkle Partners
            </Typography>
            {/* <Typography fontFamily={"poppins"} fontWeight={600} variant="h4" component="h2" gutterBottom textAlign="center">
                Find more buzzers on the partnered locations
            </Typography> */}
            <Typography fontFamily={"poppins"} fontWeight={500} mx={"30px"} color={"#30303090"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center"
                maxWidth={"500px"}>
                Time to meet some awesome venues and events!
            </Typography>


            <AutoScrollBuzzPartners images={[
                'https://lh5.googleusercontent.com/proxy/YZq9k2FKephC41xDb-jSFFP_40jEOJ5g8TmrIylhARHrCCHpFAv0aeGYTogwSgVbuFV14tozQmrw6QyqrUw',
                'https://airmenusimages.blr1.cdn.digitaloceanspaces.com/brands/brands_614_1669622779.0892334.png',
                'https://pbs.twimg.com/profile_images/1450052199673782276/xAd1mN54_400x400.jpg',
                'https://lh5.googleusercontent.com/proxy/YZq9k2FKephC41xDb-jSFFP_40jEOJ5g8TmrIylhARHrCCHpFAv0aeGYTogwSgVbuFV14tozQmrw6QyqrUw',
                'https://airmenusimages.blr1.cdn.digitaloceanspaces.com/brands/brands_614_1669622779.0892334.png',
                'https://pbs.twimg.com/profile_images/1450052199673782276/xAd1mN54_400x400.jpg',
            ]} />

        </Box>
    );
});


const Testimonials = React.forwardRef((props, ref) => {
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')

    const [currentTab, setCurrentTab] = useState(0)

    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                Testimonials
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={600} mx={"20px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                What our users say
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={500} mx={"30px"} color={"#30303090"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center"
                maxWidth={"500px"}>
                Our users found what they need on cerkle.
            </Typography>


            <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', width: isMobileScreen ? "350px" : "600px", justifyContent: 'space-between', mt: "30px" }}>

                <img src={"data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggc3R5bGU9ImxpbmUtaGVpZ2h0Om5vcm1hbDt0ZXh0LWluZGVudDowO3RleHQtYWxpZ246c3RhcnQ7dGV4dC1kZWNvcmF0aW9uLWxpbmU6bm9uZTt0ZXh0LWRlY29yYXRpb24tc3R5bGU6c29saWQ7dGV4dC1kZWNvcmF0aW9uLWNvbG9yOiMwMDA7dGV4dC10cmFuc2Zvcm06bm9uZTtibG9jay1wcm9ncmVzc2lvbjp0Yjtpc29sYXRpb246YXV0bzttaXgtYmxlbmQtbW9kZTpub3JtYWwiIGZpbGw9IiMzNDQ4NWMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibS05MzAuOTQgOTE5LjY1NS0uNzA2LjcwNy01LjM1NC01LjM1MyA1LjM1NC01LjM1NC43MDcuNzA3LTQuNjQ3IDQuNjQ3IDQuNjQ3IDQuNjQ2eiIgY29sb3I9IiMwMDAiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBmb250LXdlaWdodD0iNDAwIiBvdmVyZmxvdz0idmlzaWJsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTQyIC05MDYuMzYyKSIvPjwvc3ZnPg=="}
                    width={"40px"} height={"40px"} style={{ background: "#aaaaaa20", borderRadius: "100px", padding: "6px", cursor: 'pointer' }}
                    onClick={() => {
                        if (currentTab - 1 < 0) {
                            setCurrentTab(2)
                        } else {
                            setCurrentTab(currentTab - 1)
                        }
                    }}
                />

                <Typography fontFamily={"poppins"} fontWeight={500} variant='h7' mx={"10px"} textAlign={'center'}>
                    {
                        currentTab == 0 ? "Connecting at Cafes" : currentTab == 1 ? "Business Networking on the Go" : "Making Friends in a New City"
                    }

                </Typography>

                <img src={"data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggc3R5bGU9ImxpbmUtaGVpZ2h0Om5vcm1hbDt0ZXh0LWluZGVudDowO3RleHQtYWxpZ246c3RhcnQ7dGV4dC1kZWNvcmF0aW9uLWxpbmU6bm9uZTt0ZXh0LWRlY29yYXRpb24tc3R5bGU6c29saWQ7dGV4dC1kZWNvcmF0aW9uLWNvbG9yOiMwMDA7dGV4dC10cmFuc2Zvcm06bm9uZTtibG9jay1wcm9ncmVzc2lvbjp0Yjtpc29sYXRpb246YXV0bzttaXgtYmxlbmQtbW9kZTpub3JtYWwiIGZpbGw9IiMzNDQ4NWMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibS05MzcgOTA5LjQ2Mi43LS43IDUuMyA1LjMtNS4zIDUuMy0uNy0uNyA0LjYtNC42LTQuNi00LjZ6IiBjb2xvcj0iIzAwMCIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtd2VpZ2h0PSI0MDAiIG92ZXJmbG93PSJ2aXNpYmxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NDIgLTkwNi4zNjIpIi8+PC9zdmc+"}
                    width={"40px"} height={"40px"} style={{ background: "#aaaaaa20", borderRadius: "100px", padding: "6px", cursor: 'pointer' }}
                    onClick={() => {
                        if (currentTab + 1 > 2) {
                            setCurrentTab(0)
                        } else {
                            setCurrentTab(currentTab + 1)
                        }
                    }}
                />

            </Box>

            <Box sx={{ flexDirection: 'row', display: 'flex', alignSelf: 'center', mt: "60px", gap: "20px", flexWrap: "wrap", justifyContent: 'center', alignItems: 'center' }}>

                <Box sx={{
                    width: isMobileScreen ? "360px" : "420px", height: "320px", borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px", boxShadow: isMobileScreen ? '0px 6px 10px rgba(0, 0, 0, 0.1)' : '0px 6px 10px rgba(0, 0, 0, 0.1)'
                }}>
                    <img src={require("../../assets/images/quote.svg")}
                        style={{
                            width: "30px", height: "30px", marginTop: "15px",
                            borderRadius: "10px"
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"14px"} mt={"20px"} >

                        {currentTab == 0 ?
                            "Cerkle completely transformed my coffee shop experience. I used to just sit, sip, and work alone, but now I connect with like-minded freelancers and creatives around me. I’ve met new friends, collaborated on projects, and never feel isolated in a cafe anymore!"
                            : currentTab == 1 ? "As a traveling consultant, Cerkle has been a game-changer for my business networking. I can quickly find and meet other professionals in any city I visit. Last week, I made a valuable connection over lunch, and it turned into a lucrative collaboration!"
                                : "Moving to a new city can be lonely, but Cerkle changed that for me. Within days of settling in, I met a group of expats who showed me around. Now, I have a thriving social circle and no shortage of plans on weekends. Thank you, Cerkle!"

                        }

                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={700} color={"#303030"} fontSize={"16px"} component="h2" marginTop={"20px"} >
                        {
                            currentTab == 0 ? "Saanvi Kapoor" : currentTab == 1 ? "Kabir Joshi" : "Aditi Rao"
                        }
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#707070"} fontSize={"12px"} mb={"30px"} >
                        {
                            currentTab == 0 ? "Coffee Enthusiast, Freelancer" : currentTab == 1 ? "Marketing Consultant" : "New in Town"
                        }

                    </Typography>
                </Box>


                <Box sx={{
                    width: isMobileScreen ? "360px" : "420px", height: "320px", background: '#ffffff', boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.1)', borderRadius: "15px", display: 'flex', flexDirection: 'column',
                    padding: "20px"
                }}>
                    <img src={require("../../assets/images/quote.svg")}
                        style={{
                            width: "30px", height: "30px", marginTop: "15px",
                            borderRadius: "10px"
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"14px"} mt={"20px"} >
                        {
                            currentTab == 0 ? "One day at my favorite cafe, I opened Cerkle, and within minutes, I was having a great conversation with fellow students preparing for finals. We exchanged study tips, shared notes, and even planned a group study session. Cerkle makes socializing so easy!"
                                : currentTab == 1 ? "Thanks to Cerkle, I connected with a potential investor at a local co-working space. The app made it seamless to network in person and find people who matched my professional interests. It's like having a professional network in my pocket!"
                                    : "When I relocated for a new job, I worried about feeling disconnected. Cerkle helped me meet fellow tech enthusiasts and people who shared my hobbies. I even found a hiking buddy! It's the perfect way to build a community from scratch."
                        }                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"16px"} component="h2" marginTop={"20px"} >
                        {
                            currentTab == 0 ? "Rohan Gupta" : currentTab == 1 ? "Riya Desai" : "Vihaan Mehta"
                        }                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#707070"} fontSize={"12px"} >
                        {
                            currentTab == 0 ? "University Student" : currentTab == 1 ? "Entrepreneur" : "Software Engineer"
                        }
                    </Typography>
                </Box>

                {/* <Box sx={{
                    width: "320px", height: "340px", borderRadius: "10px", display: 'flex', flexDirection: 'column',
                    padding: "20px", boxShadow: isMobileScreen ? '0px 6px 10px rgba(0, 0, 0, 0.1)' : '0px 6px 10px rgba(0, 0, 0, 0)'
                }}>
                    <img src={require("../../assets/images/quote.svg")}
                        style={{
                            width: "30px", height: "30px", marginTop: "15px",
                            borderRadius: "10px"
                        }} />

                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#303030"} fontSize={"14px"} mt={"35px"} >
                        Lorem ipsum dolor sit amet, sed  do eiusmod, consectetur adipiscing elit, tempor incididunt ut labore et dolore magna aliqua. tempor incididunt ut labore et dolore magna aliqua
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={600} color={"#303030"} fontSize={"18px"} component="h2" gutterBottom marginTop={"20px"} >
                        Ritika Verma
                    </Typography>
                    <Typography fontFamily={"poppins"} fontWeight={500} color={"#707070"} fontSize={"12px"} >
                        Rajasthan, India
                    </Typography>
                </Box> */}

            </Box>
        </Box>
    );
});

const BuzzGallery = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:750px)')
    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 10 }}>
            <Typography fontFamily={"poppins"} fontWeight={600} color={"#e00b59"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" gutterBottom textAlign="center">
                Cerkle Gallery
            </Typography>
            <Typography fontFamily={"poppins"} fontWeight={600} mx={"20px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                Our moments with Cerkle
            </Typography>

            <Box sx={{
                background: '#ffffff', overflow: 'hidden',
                position: 'relative', mt: "15px", borderRadius: "5px"
                //maskImage: "linear-gradient(90deg, transparent, #000 20%, #000 80%, transparent)",
                //WebkitMaskImage: "linear-gradient(90deg, transparent, #706dea 10%, #706dea 80%, transparent)"
            }}>

                <AutoScrollGallery images2={[
                    require("../../assets/content/1.jpg"),
                    require("../../assets/content/2.jpg"),
                    require("../../assets/content/3.jpeg"),
                    require("../../assets/content/4.jpeg"),
                ]}
                    images1={[
                        require("../../assets/content/5.jpeg"),
                        require("../../assets/content/6.jpeg"),
                        require("../../assets/content/7.jpeg"),
                        require("../../assets/content/8.jpeg"),

                    ]} />
            </Box>


        </Box>
    );
});

const ContactUsForm = () => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1150px)')

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');



    const submitDetails = async () => {
        try {
            const response = await fetch(`${API_URL}/web/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ name, email, message })
            });

            const json = await response.json();

            if (json.success) {
                // Handle successful submission (e.g., display a success message)
                alert('Your message has been sent successfully!');
                setName("")
                setEmail("")
                setMessage("")
            } else {
                // Handle errors (e.g., display an error message)
                alert(json.response);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An unexpected error occurred. Please try again later.');
        }
    };

    return (
        <Box sx={{
            flexDirection: 'column', display: 'flex', background: '#ffffff', borderRadius: "15px", padding: isMobileScreen ? "15px" : "25px", alignSelf: 'stretch',
            marginInline: isMobileScreen ? "10px" : "0px", width: isMobileScreen ? "auto" : isTabScreen ? "400px" : "500px"
        }}>

            <Typography style={{ fontFamily: 'poppins', fontWeight: 500, fontSize: "12px", color: "#303030", marginLeft: "3px", marginTop: "30px" }}>Name</Typography>
            <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px", alignSelf: 'stretch'
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'text'}
                placeholder='Enter your name'
            />

            <Typography style={{ fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px", marginTop: "20px" }}>Email</Typography>
            <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'email'}
                placeholder='Enter your email address'
            />

            <Typography style={{ fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px", marginTop: "20px" }}>Message</Typography>
            <TextField
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                    verticalAlign: 'top', textAlign: 'left', flex: 1,
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                        textAlign: 'left', verticalAlign: 'top', minHeight: "130px"
                    }
                }}
                multiline
                placeholder='Enter your message'
            />

            <Typography
                onClick={submitDetails}
                style={{
                    cursor: 'pointer',
                    color: '#ffffff', fontFamily: 'poppins', fontSize: "14px", background: '#333946', borderRadius: "4px", fontWeight: 500,
                    marginTop: "40px", textAlign: 'center', paddingBottom: "10px", paddingTop: "10px"
                }}
            >
                Submit
            </Typography>

        </Box>
    )
}

const BuzzContactUs = React.forwardRef(({ route }, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:1000px)');
    const isTabScreen = useMediaQuery('(max-width:1500px)')
    return (
        <Box ref={ref} sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', background: "#333946", paddingTop: isMobileScreen ? "40px" : "60px" }}>


            <Box sx={{
                alignSelf: 'stretch', marginInline: isMobileScreen ? "20px" : isTabScreen ? "50px" : "250px", flexDirection: 'row', display: 'flex',
                marginTop: isMobileScreen ? "0px" : "40px", marginBottom: "80px",
                justifyContent: isMobileScreen ? 'center' : "space-between", alignItems: 'center',
            }}>

                <Box sx={{ flexDirection: 'column', alignItems: isMobileScreen ? 'center' : 'flex-start', display: 'flex', }}>

                    <Typography fontFamily={"poppins"} fontWeight={500} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign={isMobileScreen ? "center" : "left"} color={"#ffffff"}>
                        Get in touch with us
                    </Typography>
                    <Typography textAlign={isMobileScreen ? "center" : "left"} fontFamily={"poppins"} fontWeight={300} color={"#ffffff90"} fontSize={isMobileScreen ? "13px" : "15px"} component="h2" maxWidth={"350px"}>
                        Fill out the form below or schedule a meeting with us at your convenience.
                    </Typography>

                    <Box sx={{
                        height: "1px", alignSelf: 'stretch', background: "#ffffff10", marginTop: "30px", maxWidth: isMobileScreen ? "100%" : "300px",
                        marginBottom: isMobileScreen ? "20px" : "0px"
                    }} />

                    {
                        isMobileScreen && (
                            <ContactUsForm />
                        )
                    }

                    <Typography fontFamily={"poppins"} fontWeight={400} color={"#ffffff"} fontSize={"16px"} mt={"30px"} component="h2" maxWidth={"500px"}>
                        You can also contact us via following below
                    </Typography>


                    <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'flex-start', marginTop: "30px", cursor: 'pointer' }}>
                        <img src={require("../../assets/images/email.svg")} style={{ width: '16px', height: "16px", filter: "invert()", marginTop: '2px' }} />
                        <Typography style={{
                            fontFamily: 'poppins',
                            fontSize: '14px',
                            fontWeight: 300,
                            maxWidth: "310px",
                            color: '#e5e5e5',
                            marginLeft: "10px"
                        }} >support@vybecerkle.com</Typography>
                    </Box>



                    <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'flex-start', marginTop: "20px", cursor: 'pointer' }}>
                        <img src={require("../../assets/images/location.svg")} style={{ width: '16px', height: "16px", filter: "invert()", marginTop: '2px' }} />
                        <Typography style={{
                            fontFamily: 'poppins',
                            fontSize: '14px',
                            fontWeight: 300,
                            maxWidth: "310px",
                            color: '#e5e5e5',
                            marginLeft: "10px",
                            textAlign: isMobileScreen ? "center" : "left"
                        }} >47/1/F, Hazra Road, Ballygunge, Kolkata - 700019</Typography>
                    </Box>


                    <Box sx={{ flexDirection: 'row', display: 'flex', marginTop: "40px" }}>
                        <img onClick={() => {
                            window.open('https://www.facebook.com/buzz.konnxt?mibextid=ZbWKwL', '_blank');
                        }} src={require("../../assets/images/facebook.svg")} style={{
                            width: '24px', height: "24px", filter: "invert()", marginTop: '2px', marginRight: "25px",
                            cursor: 'pointer'
                        }} />
                        <img onClick={() => {
                            window.open('https://www.instagram.com/vybecerkle/', '_blank');
                        }} src={require("../../assets/images/insta.svg")} style={{
                            width: '24px', height: "24px", filter: "invert()", marginTop: '2px',
                            cursor: "pointer"
                        }} />


                    </Box>

                    <Box sx={{ marginTop: isMobileScreen ? '10px' : '50px', flexDirection: isMobileScreen ? 'column' : 'row', display: 'flex', marginLeft: isMobileScreen ? "0px" : "-10px" }}>
                        <DownloadButton onClick={() => {
                            window.open('https://apps.apple.com/in/app/cerkle/id6749543299', '_blank');
                        }} style={{
                            background: '#ffffff'
                        }} variant="contained" color="#303030">
                            <img src={require("../../assets/images/apple.svg")} style={{ width: '15px', height: "15px" }} />
                            <Typography style={{
                                fontFamily: 'poppins',
                                fontSize: isMobileScreen ? '13px' : '13px',
                                fontWeight: 400,
                                color: '#000000',
                                marginLeft: "10px"
                            }} >Download from App Store</Typography>
                        </DownloadButton>
                        <DownloadButton onClick={() => {
                            window.open('https://play.google.com/store/apps/details?id=com.vybecerkle.cerkle', '_blank');
                        }} variant="contained" style={{
                            border: "1px solid #ffffff"
                        }} color="#303030">
                            <img src={require("../../assets/images/play-store-dark.svg")} style={{ width: '15px', height: "15px", filter: "invert()" }} />
                            <Typography style={{
                                fontFamily: 'poppins',
                                fontSize: isMobileScreen ? '13px' : '13px',
                                fontWeight: isMobileScreen ? 500 : 400,
                                marginLeft: "10px",
                                flex: 1,
                                textAlign: 'center',
                                color: 'white'
                            }}>Get it on Google Play</Typography>
                        </DownloadButton>

                    </Box>



                    <Box sx={{ height: "1px", alignSelf: 'stretch', background: "#ffffff10", marginTop: "30px", maxWidth: "300px" }} />

                    <Box sx={{ marginTop: "20px", flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                        <Typography
                            onClick={() => {
                                window.location.href = `${BASE_URL}/terms-of-service`
                            }}
                            style={{ cursor: 'pointer', color: "white", textDecoration: "underline", fontFamily: 'poppins', fontWeight: 300, fontSize: "12px", marginRight: "20px" }} >
                            Terms of Service</Typography>
                        <Typography
                            onClick={() => {
                                window.location.href = `${BASE_URL}/privacy-policy`
                            }}
                            style={{ color: "white", cursor: 'pointer', textDecoration: "underline", fontFamily: 'poppins', fontWeight: 300, fontSize: "12px" }} >
                            Privacy Policy</Typography>

                    </Box>

                </Box>

                {
                    !isMobileScreen && (
                        <ContactUsForm />
                    )
                }


            </Box>

            <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', marginBottom: "10px" }}>
                <Typography sx={{ color: '#ffffff90', fontFamily: 'poppins', fontWeight: 300, fontSize: "12px", }}>
                    Copyright © 2025. Powered by </Typography>

                <img style={{ width: "70px", height: "50px", marginLeft: "5px", filter: 'invert()' }}  src={require("../../assets/images/vb_logo.svg")} />
            </Box>


        </Box>
    );
});


const BuzzHome = () => {

    const navigate = useNavigate()

    const section1Ref = useRef(null);
    const section2Ref = useRef(null);
    const section3Ref = useRef(null);
    const section4Ref = useRef(null);
    const section5Ref = useRef(null);
    const section6Ref = useRef(null);
    const section7Ref = useRef(null);
    const section8Ref = useRef(null);

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>

            <Helmet>
                <title>Cerkle</title>
                <meta name="description" content="Connect with people in your cerkle" />
                <meta name="keywords" content="Buzz, cerkle, Crew, Community, Fun, Discover" />
                <meta property="og:title" content="Cerkle" />
                <meta property="og:description" content="Connect with people in your cerkle" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/buzz-dev-1.appspot.com/o/cerkle_logo_new.png?alt=media&token=2ab31e6d-9c11-4e4e-9cd9-3032776872a6" />
                <meta property="og:url" content="https://vybecerkle.com" />
            </Helmet>
            <BuzzHeader onSelect={(pos) => {
                switch (pos) {
                    case 1:
                        scrollToSection(section1Ref)
                        break;
                    case 2:
                        scrollToSection(section2Ref)
                        break;
                    case 3:
                        scrollToSection(section3Ref)
                        break;
                    case 4:
                        scrollToSection(section5Ref)
                        break;
                    case 5:
                        scrollToSection(section7Ref)
                        break;

                    case 6:
                        scrollToSection(section8Ref)
                        break;

                    default:
                        break;
                }
            }} />

            <HeroSection ref={section1Ref} />
            <HowToBuzz ref={section2Ref} />
            <FeaturesSection ref={section3Ref} />
            <ConnectionTypes ref={section4Ref} />
            <BuzzPartnered ref={section5Ref} />
            <Testimonials ref={section6Ref} />
            {/* <BuzzGallery ref={section7Ref} /> */}
            <BuzzContactUs route={navigate} ref={section8Ref} />
        </>
    );
};

export default BuzzHome;
